import { render } from "./CIS-CTA-Tertiary.vue?vue&type=template&id=727b8c90"
import script from "./CIS-CTA-Tertiary.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Tertiary.vue?vue&type=script&lang=js"

import "./CIS-CTA-Tertiary.vue?vue&type=style&index=0&id=727b8c90&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__